"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetStatus = void 0;
const react_1 = __importDefault(require("react"));
const no_data_components_1 = require("./skeleton-and-no-data-state/no-data.components");
const skeleton_and_no_data_state_styles_1 = require("./skeleton-and-no-data-state/skeleton-and-no-data-state.styles");
const WidgetStatus = ({ isLoading, noData, skeletonComponent, }) => {
    if (!isLoading && !noData)
        return null;
    if (isLoading) {
        return skeletonComponent;
    }
    if (noData) {
        return (react_1.default.createElement(skeleton_and_no_data_state_styles_1.WidgetStatusContainer, null, react_1.default.createElement("div", { className: "blur-overlay" }, skeletonComponent), react_1.default.createElement(skeleton_and_no_data_state_styles_1.NoDataOverlay, null, react_1.default.createElement(no_data_components_1.NoDataComponent, null))));
    }
};
exports.WidgetStatus = WidgetStatus;
